import { SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './finance-offer-card.module.css'
import Image from 'next/image'

interface FinanceOfferCardProps {
  image: {
    src: string
    alt: string
  }
  banner: string
  title: string
  offerDetails: string[]
  footerText: string
}

export const FinanceOfferCard = ({
  image,
  banner,
  title,
  offerDetails,
  footerText,
}: FinanceOfferCardProps) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <Image
        src={image.src}
        alt={image.alt}
        fill={true}
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </div>
    <div className={styles.banner}>
      <Text className={styles.text}>{banner}</Text>
    </div>
    <div className={styles.infoSection}>
      <Text className={styles.title}>{title}</Text>
      <div>
        {offerDetails.map((detail, index) => (
          <div key={index} className={styles.bulletPoint}>
            <SvgIcon name={'tick'} size={16} />
            <Text className={styles.text}>{detail}</Text>
          </div>
        ))}
      </div>
      <Text className={styles.footerText}>{footerText}</Text>
    </div>
  </div>
)
